function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import CheckCircle from 'svg/check-green-circle.svg';
import { AppContext } from 'context';
import LoaderCircle from 'svg/loader-circle.svg';
import ErrorRedCircle from 'svg/error-red-cricle.svg';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../messagePage.pcss';
var _React_PureComponent;
class SignOut extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        if (props.isInProgress && !state.isInProgress) {
            return {
                isInProgress: true,
                hasErrors: true
            };
        }
        if (!props.isInProgress && state.isInProgress) {
            return {
                isInProgress: false,
                hasErrors: props.hasErrors
            };
        }
        return null;
    }
    componentDidMount() {
        const { logoutId } = this.props;
        if (logoutId) {
            this.props.onSignOutCallback(logoutId);
        }
    }
    get isInProgress() {
        return this.state.isInProgress;
    }
    get hasErrors() {
        return this.state.hasErrors;
    }
    get signInUrl() {
        return this.context.getUrl('sign-in');
    }
    get headerIcon() {
        if (this.isInProgress) {
            return /*#__PURE__*/ _jsx(LoaderCircle, {
                className: cn(styles.headerIcon, 'rotating')
            });
        }
        if (this.hasErrors) {
            return /*#__PURE__*/ _jsx(ErrorRedCircle, {
                className: styles.headerIcon
            });
        }
        return /*#__PURE__*/ _jsx(CheckCircle, {
            className: styles.headerIcon
        });
    }
    get messageHeader() {
        if (this.isInProgress) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.loggingOutInProgress));
        }
        if (this.hasErrors) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.somethingWrong));
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.seeYouLater));
    }
    get messageDetails() {
        if (this.isInProgress) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.profileSecure));
        }
        if (this.hasErrors) {
            const goBack = (chunk)=>/*#__PURE__*/ _jsx("a", {
                    href: this.signInUrl,
                    children: chunk
                });
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.tryLoggingOutAgain), {
                values: {
                    goBack
                }
            }));
        }
        const clickHereToSignInAgain = (chunk)=>/*#__PURE__*/ _jsx("a", {
                href: this.signInUrl,
                children: chunk
            });
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.loggingOutSuccessful), {
            values: {
                clickHereToSignInAgain
            }
        }));
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.wrapper,
            children: [
                this.headerIcon,
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.message,
                    children: [
                        /*#__PURE__*/ _jsx("header", {
                            className: styles.messageHeader,
                            children: /*#__PURE__*/ _jsx("h1", {
                                className: "text--h1",
                                children: this.messageHeader
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.messageDetails,
                            children: this.messageDetails
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false,
            hasErrors: false
        };
    }
}
_define_property(SignOut, "contextType", AppContext);
_define_property(SignOut, "propTypes", {
    // Explicit props
    logoutId: PropTypes.string,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onSignOutCallback: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isSignOutCallbackInProgress(state),
        hasErrors: selectors.hasSignOutCallbackError(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSignOutCallback: (logoutId)=>dispatch(actions.signOutCallback(logoutId))
    });
const ConnectedSignOut = connect(mapStateToProps, mapDispatchToProps)(SignOut);
export default withStyles(styles)(ConnectedSignOut);
